// action
import {
    DELETE_QUICK_SUPPORT_CATEGORY,
    DELETE_QUICK_SUPPORT_CATEGORY_FAIL,
    DELETE_QUICK_SUPPORT_CATEGORY_SUCCESS,
    DELETE_QUICK_SUPPORT_CATEGORY_RESET
} from '../action/deleteQuickSupportCategoryAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case DELETE_QUICK_SUPPORT_CATEGORY:
            return {
                ...state,
                apiState: "loading"
            }
        case DELETE_QUICK_SUPPORT_CATEGORY_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case DELETE_QUICK_SUPPORT_CATEGORY_SUCCESS:
            return {
                ...state,
                apiState: "success",
                message: action.response.data.message,
            }
        case DELETE_QUICK_SUPPORT_CATEGORY_RESET:
            return initialState
        default:
            return state
    }
}